import React from 'react';
import type { GikIconProps } from '.';
import { GikIconDefaultSize } from '.';

export const Handle = React.forwardRef(
  (
    { size = GikIconDefaultSize, color, ...props }: GikIconProps & { color?: string },
    svgRef: React.Ref<SVGSVGElement>
  ) => {
    return (
      <svg
        width={size}
        height={size}
        ref={svgRef}
        viewBox="0 -3 28 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M0 16.6166C0 23.7963 5.8203 29.7256 13 29.7256C20.1797 29.7256 26 23.7963 26 16.6166C26 13.1582 24.638 9.79364 22.2088 7.33196L17.4022 2.46107C14.9804 0.00693321 11.0196 0.00693321 8.59781 2.46107L3.7912 7.33196C1.36201 9.79364 0 13.1582 0 16.6166Z"
          fill={color}
        />
      </svg>
    );
  }
);
